import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateGameUserSwitchActive = {
  gameUserSwitchActive: { data: null, loading: false, error: null },
};

export const gameUserSwitchActive = createAsyncThunk('user/gameUserSwitchActive', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/game/user/switch-active`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGameUserSwitchActive = {
  [gameUserSwitchActive.pending]: (state) => {
    state.gameUserSwitchActive.loading = true;
  },
  [gameUserSwitchActive.fulfilled]: (state, action) => {
    state.gameUserSwitchActive.loading = false;
    state.gameUserSwitchActive.data = action.payload;
    state.gameUserSwitchActive.error = null;
  },
  [gameUserSwitchActive.rejected]: (state, action) => {
    state.gameUserSwitchActive.loading = false;
    state.gameUserSwitchActive.error = action.payload;
  },
};
